
































































































































































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySac from '@/components/filters/FilterDeliverySac.vue'
import DeliverySacRequest from '@/model/request/DeliverySacRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import SacResponse from '@/model/response/SacResponse'
import DeliverySacResponse from '@/model/response/DeliverySacResponse'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import {snakeCase} from 'lodash'

enum State {
    INIT = 1,
    SELECTED = 2,
    LISTED = 3,
}

const metaInfo = () => ({
    title: $.t('view.reports.deliverySac.title'),
})

@Component({
    metaInfo,
    components: {FilterToggle, FilterDeliverySac, itTrackingSlider},
})
export default class ReportsDeliverySacView extends Mixins(MixinFilter) {
    AppConfig = AppConfig
    State = State

    state = State.INIT

    // Selected item
    model: Carga | null = null

    filter = new DeliverySacRequest()
    filterSac = new DeliverySacRequest()

    collection = new CargaCollection(this.filter, '/user/carga/sac', 10)
    collectionSac = new PageCollection(SacResponse, this.filterSac, null, null)

    showFilter = true
    populateOnMount = false

    @Watch('collection.items', {deep: true})
    listEvent(items: Carga[]) {
        if (!this.filter.isCleared && items.length === 1) {
            this.select(items[0])
        }
    }

    @Watch('state')
    async stateEvent(state: State) {
        if (state === State.LISTED) {
            this.model = null
            this.collectionSac.items = []
            this.filterSac.idCarga = null
        } else if (state === State.SELECTED) {
            await Helper.sleep(1000)
            if (this.model) {
                this.filterSac.docs = `${this.model.nroNotaFiscal}`
                this.filterSac.idCarga = this.model.idCargaPk as number
                await this.collectionSac.search()
            }
        } else if (state === State.INIT) {
            this.model = null

            this.filter.clean()
            this.filterSac.clean()

            this.collection.items = []
            this.collectionSac.items = []

            this.showFilter = false
            await this.$nextTick()
            this.showFilter = true
        }
    }

    async downloadData(xlsx: boolean) {
        const filterToGenerateReport = this.filter

        if (this.state === State.SELECTED) {
            filterToGenerateReport.idCarga =  this.model && this.model.idCargaPk ? this.model.idCargaPk as number : null
        } else {
            filterToGenerateReport.idCarga =  null
        }

        if (!xlsx) {
            const csv = new PageCollection(DeliverySacResponse, filterToGenerateReport, null, null)
            const fetch = async () => await csv.search()
            await $.await.run(fetch, 'download')
            csv.downloadCsv(snakeCase($.t('classes.DeliverySacResponse.title')))
        } else {
            await $.await.run(() => Helper.downloadXlsx(
                $.t('classes.DeliverySacResponse.title'),
                new DeliverySacResponse().$endpoint,
                filterToGenerateReport,
                DeliverySacResponse,
                'DeliverySacResponse',
            ), 'download')
        }
    }

    get eyeIcon() {
        return `<img src="./img/itrack/view-circle-contrast.svg" alt="view-circle">`
    }

    get lastSac() {
        const items = this.collectionSac.items
        return items[items.length - 1]
    }

    get cargaSessionPrivateAlt() {
      return Helper.isIvecoCnh() && this.model && this.model.showMapaTelaSacPrivado ?
        AppConfig.fieldsToRender.reportsDeliverySac.CargaSessionPrivateAltIvecoCnh
        : AppConfig.fieldsToRender.reportsDeliverySac.CargaSessionPrivateAlt
    }

    list() {
        this.state = State.LISTED
    }

    select(model: Carga) {
        this.state = State.SELECTED
        this.model = model
    }

    init() {
        this.state = State.INIT
    }

    async filtrateSac() {
        if (this.filter.isCleared) {
            this.init()
        } else {
            this.list()
        }
        await this.filtrate()
    }

    async clean() {
        this.filter.clean()
        this.init()
        await this.filtrate()
    }

    async populate() {
        await Helper.sleep(1000)
        await this.query()
    }

    async created() {
        this.collection.orderBy = 'idCargaPk'
        this.collection.asc = true
    }
}
